import KickOffOutOfBounds from "./kick-off-out-of-bounds";

// persisted game configs predating the kickoffOutOfBounds spot fall back to this
const DEFAULT_KICKOFF_OUT_OF_BOUNDS_YARDLINE = 5;

export const getKickoffOutOfBoundsYardline = (homePossession, gameConfig) => {
    const { fieldLength } = gameConfig.general;

    const yardline =
        gameConfig.spots.kickoffOutOfBounds ??
        DEFAULT_KICKOFF_OUT_OF_BOUNDS_YARDLINE;

    return homePossession ? yardline : fieldLength - yardline;
};

export default class IndoorKickOffOutOfBounds extends KickOffOutOfBounds {
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        await super.apply(gameContext, ruleContext, eventConfiguration, {
            play,
            fragment
        });
        // switchPossession already ran, so homeTeamHasPossession is the receiving team
        gameContext.setFieldPosition(
            getKickoffOutOfBoundsYardline(
                gameContext.homeTeamHasPossession,
                gameContext.gameConfig
            )
        );
    }
}
